"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get AiResponseEnvelope () {
        return AiResponseEnvelope;
    },
    get AskConfidenceLevel () {
        return AskConfidenceLevel;
    },
    get AskSSEChunkEvent () {
        return AskSSEChunkEvent;
    },
    get AskSSECompetenciesInterviewerOutput () {
        return AskSSECompetenciesInterviewerOutput;
    },
    get AskSSECompetencyLevel () {
        return AskSSECompetencyLevel;
    },
    get AskSSECompetencySuggestion () {
        return AskSSECompetencySuggestion;
    },
    get AskSSEDoneEvent () {
        return AskSSEDoneEvent;
    },
    get AskSSEErrorEvent () {
        return AskSSEErrorEvent;
    },
    get AskSSEEventSchema () {
        return AskSSEEventSchema;
    },
    get AskSSEExitInterviewerEvent () {
        return AskSSEExitInterviewerEvent;
    },
    get AskSSEFormQuestionSuggestion () {
        return AskSSEFormQuestionSuggestion;
    },
    get AskSSEFormQuestionType () {
        return AskSSEFormQuestionType;
    },
    get AskSSEFormQuestionsEvent () {
        return AskSSEFormQuestionsEvent;
    },
    get AskSSEFormRatingScaleOption () {
        return AskSSEFormRatingScaleOption;
    },
    get AskSSEFormSuggestion () {
        return AskSSEFormSuggestion;
    },
    get AskSSEFormsEvent () {
        return AskSSEFormsEvent;
    },
    get AskSSEGoalSuggestion () {
        return AskSSEGoalSuggestion;
    },
    get AskSSEGoalsEvent () {
        return AskSSEGoalsEvent;
    },
    get AskSSEInterviewNotesEvent () {
        return AskSSEInterviewNotesEvent;
    },
    get AskSSEInterviewerOutputEvent () {
        return AskSSEInterviewerOutputEvent;
    },
    get AskSSEReportingAnalyticsInterviewerOutput () {
        return AskSSEReportingAnalyticsInterviewerOutput;
    },
    get AskSSEStatusEvent () {
        return AskSSEStatusEvent;
    },
    get AskSSEToolCallEvent () {
        return AskSSEToolCallEvent;
    },
    get AskScoreSource () {
        return AskScoreSource;
    },
    get AskSource () {
        return AskSource;
    },
    get AskStreamStage () {
        return AskStreamStage;
    },
    get ChunkProcessingResponse () {
        return ChunkProcessingResponse;
    },
    get DefaultRephraseResponseStream () {
        return DefaultRephraseResponseStream;
    },
    get EngagementCohortInsightResponseStream () {
        return EngagementCohortInsightResponseStream;
    },
    get EngagementInsightResponseStream () {
        return EngagementInsightResponseStream;
    },
    get GetCompanyAISettingsResponse () {
        return GetCompanyAISettingsResponse;
    },
    get HasAccessibleDocumentsResponse () {
        return HasAccessibleDocumentsResponse;
    },
    get MeetingWorkspaceInsightResponseStream () {
        return MeetingWorkspaceInsightResponseStream;
    },
    get MetaDataChunkProcessingResponse () {
        return MetaDataChunkProcessingResponse;
    },
    get MetaDataDefaultRephraseResponseStream () {
        return MetaDataDefaultRephraseResponseStream;
    },
    get MetaDataEngagementCohortInsightResponseStream () {
        return MetaDataEngagementCohortInsightResponseStream;
    },
    get MetaDataEngagementInsightResponseStream () {
        return MetaDataEngagementInsightResponseStream;
    },
    get MetaDataMeetingWorkspaceInsightResponseStream () {
        return MetaDataMeetingWorkspaceInsightResponseStream;
    },
    get MetaDataPreMeetingPrepResponseStream () {
        return MetaDataPreMeetingPrepResponseStream;
    },
    get MetaDataReviewCycleInsightResponseStream () {
        return MetaDataReviewCycleInsightResponseStream;
    },
    get MetaDataReviewInsightResponseStream () {
        return MetaDataReviewInsightResponseStream;
    },
    get MetaDataSurveyInsightResponseStream () {
        return MetaDataSurveyInsightResponseStream;
    },
    get MetaDataTeamMeetingWorkspaceInsightResponseStream () {
        return MetaDataTeamMeetingWorkspaceInsightResponseStream;
    },
    get PatchCompanyAISettingsResponse () {
        return PatchCompanyAISettingsResponse;
    },
    get PostCompanyAISettingsResponse () {
        return PostCompanyAISettingsResponse;
    },
    get PostEmbeddingsResponse () {
        return PostEmbeddingsResponse;
    },
    get PreMeetingPrepResponseStream () {
        return PreMeetingPrepResponseStream;
    },
    get ReviewCycleInsightResponseStream () {
        return ReviewCycleInsightResponseStream;
    },
    get ReviewInsightResponseStream () {
        return ReviewInsightResponseStream;
    },
    get SurveyInsightResponseStream () {
        return SurveyInsightResponseStream;
    },
    get TeamMeetingWorkspaceInsightResponseStream () {
        return TeamMeetingWorkspaceInsightResponseStream;
    },
    get buildMeetingWorkspaceInsightSchema () {
        return buildMeetingWorkspaceInsightSchema;
    },
    get buildPreMeetingPrepSchema () {
        return buildPreMeetingPrepSchema;
    },
    get buildReviewCycleInsightSchema () {
        return buildReviewCycleInsightSchema;
    },
    get buildTeamMeetingWorkspaceInsightSchema () {
        return buildTeamMeetingWorkspaceInsightSchema;
    },
    get createSurveyInsightResponseStream () {
        return createSurveyInsightResponseStream;
    }
});
const _zod = require("zod");
const _models = require("@performyard/models");
const _harnesstypes = require("./harness-types");
const AiResponseEnvelope = _zod.z.object({
    promptHash: _zod.z.string(),
    isCached: _zod.z.boolean(),
    status: _zod.z.enum([
        "in_progress",
        "completed"
    ]),
    userId: _zod.z.string().optional(),
    createdBy: _zod.z.string().optional(),
    createdAt: _zod.z.date(),
    taskId: _zod.z.string().optional()
});
const PostEmbeddingsResponse = _zod.z.object({
    success: _zod.z.boolean()
});
const PostCompanyAISettingsResponse = _zod.z.object({
    success: _zod.z.boolean()
});
const PatchCompanyAISettingsResponse = _zod.z.object({
    success: _zod.z.boolean()
});
const GetCompanyAISettingsResponse = _models.AiSettingsSchema;
const ReviewInsightResponseStream = _zod.z.object({
    createdAt: _zod.z.string().default(new Date().toISOString()),
    completed: _zod.z.boolean().default(false),
    createdBy: _zod.z.string().default("Automated Insights"),
    subject: _zod.z.object({
        _id: _zod.z.string().describe("The ID of the subject"),
        name: _zod.z.string().describe("The name of the subject")
    }),
    title: _zod.z.string(),
    startDate: _zod.z.string().default(new Date().toISOString()),
    completedDate: _zod.z.string().default(new Date().toISOString()),
    insight: _zod.z.object({
        summary: _zod.z.string(),
        strengths: _zod.z.array(_zod.z.string()).optional(),
        opportunities: _zod.z.array(_zod.z.string()).optional(),
        actionItems: _zod.z.array(_zod.z.string()).optional(),
        disconnects: _zod.z.array(_zod.z.string()).optional(),
        generalAssessment: _zod.z.string().default(""),
        quotes: _zod.z.array(_zod.z.string()).optional(),
        tone: _zod.z.string().optional()
    })
});
const MetaDataReviewInsightResponseStream = _zod.z.object({
    data: ReviewInsightResponseStream
}).extend(AiResponseEnvelope.shape);
const DefaultRephraseResponseStream = _zod.z.object({
    answer: _zod.z.array(_zod.z.string()),
    detectedLanguage: _zod.z.string().optional(),
    genderedPronounsFound: _zod.z.array(_zod.z.string()),
    pronounRuleApplied: _zod.z.string()
});
const MetaDataDefaultRephraseResponseStream = _zod.z.object({
    data: DefaultRephraseResponseStream
}).extend(AiResponseEnvelope.shape);
// Base insight schema with all possible fields
const BaseSurveyInsightSchema = _zod.z.object({
    summary: _zod.z.string().describe("4-5 sentences minimum covering participation rate, key statistical findings, main themes from open-ended responses, demographic insights, and business impact."),
    sentiment: _zod.z.string().nullable().describe("string with numerical score (X/10) and detailed explanation including specific evidence from both rating data and open-ended responses, segmented by demographics where relevant.").optional(),
    keyThemesAndPatterns: _zod.z.array(_zod.z.string()).transform((arr)=>arr.slice(0, 3)).describe("The key themes and patterns of the survey.").optional(),
    outliers: _zod.z.array(_zod.z.string()).transform((arr)=>arr.slice(0, 4)).describe("The outliers of the survey.").optional(),
    crossQuestionInsights: _zod.z.array(_zod.z.string()).transform((arr)=>arr.slice(0, 3)).describe("The cross question insights of the survey.").optional(),
    recommendations: _zod.z.array(_zod.z.string()).transform((arr)=>arr.slice(0, 3)).describe("The recommendations of the survey.").optional(),
    demographicInsights: _zod.z.object({
        roleBasedAnalysis: _zod.z.string().optional(),
        jobTitlePatterns: _zod.z.string().optional(),
        responseRateByDemographics: _zod.z.string().optional(),
        demographicSpecificConcerns: _zod.z.string().optional()
    }).describe("The demographic insights of the survey.").optional()
});
const createSurveyInsightResponseStream = (settings)=>{
    const insightFields = {
        summary: BaseSurveyInsightSchema.shape.summary
    };
    // Only include fields that are enabled in settings
    if (settings.sentimentAnalysis) {
        insightFields.sentiment = BaseSurveyInsightSchema.shape.sentiment;
    }
    if (settings.keyThemesAndPatterns) {
        insightFields.keyThemesAndPatterns = BaseSurveyInsightSchema.shape.keyThemesAndPatterns;
    }
    if (settings.outliersAndNotableResponses) {
        insightFields.outliers = BaseSurveyInsightSchema.shape.outliers;
    }
    if (settings.actionableInsightsAndRecommendations) {
        insightFields.recommendations = BaseSurveyInsightSchema.shape.recommendations;
    }
    if (settings.demographicInsights) {
        insightFields.demographicInsights = BaseSurveyInsightSchema.shape.demographicInsights;
    }
    if (settings.crossQuestionInsights) {
        insightFields.crossQuestionInsights = BaseSurveyInsightSchema.shape.crossQuestionInsights;
    }
    return _zod.z.object({
        title: _zod.z.string().describe("The name of the survey"),
        startDate: _zod.z.string().nullable().describe("Start date of the analysis window in ISO 8601 format"),
        completedDate: _zod.z.string().nullable().describe("End date of the analysis window in ISO 8601 format"),
        totalResponses: _zod.z.number().describe("The total number of responses."),
        createdAt: _zod.z.string().default(new Date().toISOString()),
        createdBy: _zod.z.string().default("Automated Insights"),
        insight: _zod.z.object(insightFields)
    });
};
const SurveyInsightResponseStream = _zod.z.object({
    title: _zod.z.string().describe("The name of the survey"),
    startDate: _zod.z.string().nullable().describe("Start date of the analysis window in ISO 8601 format"),
    completedDate: _zod.z.string().nullable().describe("End date of the analysis window in ISO 8601 format"),
    totalResponses: _zod.z.number().describe("The total number of responses."),
    createdAt: _zod.z.string().default(new Date().toISOString()),
    createdBy: _zod.z.string().default("Automated Insights"),
    insight: BaseSurveyInsightSchema
});
const MetaDataSurveyInsightResponseStream = _zod.z.object({
    data: SurveyInsightResponseStream
}).extend(AiResponseEnvelope.shape);
const EngagementInsightResponseStream = _zod.z.object({
    question: _zod.z.string().describe("The question that was asked. Do not change the question from the original."),
    cohortName: _zod.z.string().describe("The cohort or team name the question was sent to."),
    startDate: _zod.z.string().nullable().describe("Start date of the analysis window in ISO 8601 format"),
    endDate: _zod.z.string().nullable().describe("End date of the analysis window in ISO 8601 format"),
    createdAt: _zod.z.string().default(new Date().toISOString()),
    createdBy: _zod.z.string().default("Automated Insights"),
    insight: _zod.z.object({
        summary: _zod.z.string().describe("Three-sentence summary of the key findings"),
        overallSentiment: _zod.z.string().describe("Overall sentiment with percentage breakdown ex: Negative (62% negative, 25% mixed, 13% positive) Do not include No Data Available"),
        positiveExamples: _zod.z.array(_zod.z.string()).describe("Up to 3 examples of positive responses. Use array format for responses with lists, string format for regular responses. Use complete original text.").transform((arr)=>arr.slice(0, 3)),
        mixedExamples: _zod.z.array(_zod.z.string()).describe("Up to 3 examples of mixed responses. Use array format for responses with lists, string format for regular responses. Use complete original text.").transform((arr)=>arr.slice(0, 3)),
        negativeExamples: _zod.z.array(_zod.z.string()).describe("Up to 3 examples of negative responses. Use array format for responses with lists, string format for regular responses. Use complete original text.").transform((arr)=>arr.slice(0, 3)),
        themes: _zod.z.record(_zod.z.string(), _zod.z.string()).describe("A set of key themes extracted from the responses. If there are no themes return an empty object."),
        recommendations: _zod.z.array(_zod.z.string()).describe("Up to 3 actionable suggestions with a 2 sentence explanation. If there are no recommendations respond with `No Data Available`").transform((arr)=>arr.slice(0, 3))
    })
});
const MetaDataEngagementInsightResponseStream = _zod.z.object({
    data: EngagementInsightResponseStream
}).extend(AiResponseEnvelope.shape);
const EngagementCohortInsightResponseStream = _zod.z.object({
    createdAt: _zod.z.string().default(new Date().toISOString()),
    completed: _zod.z.boolean().default(false),
    createdBy: _zod.z.string().default("Automated Insights"),
    userId: _zod.z.string(),
    insight: _zod.z.object({
        executiveSummary: _zod.z.string(),
        keyPerformanceAreas: _zod.z.record(_zod.z.string(), _zod.z.object({
            score: _zod.z.string().describe("Score analysis with format: X.X/5 for all employees or X.X for specific cohorts"),
            potentialReasons: _zod.z.array(_zod.z.string()).min(1).max(3).describe("1-3 bulleted reasons why this score may exist"),
            recommendations: _zod.z.array(_zod.z.string()).min(1).max(3).describe("1-3 bulleted recommendations on how to increase/maintain score"),
            explanation: _zod.z.string().describe("Summary explanation paragraph")
        })),
        ENPSImprovementStrategies: _zod.z.object({
            promoterStrategies: _zod.z.array(_zod.z.string()),
            detractorStrategies: _zod.z.array(_zod.z.string()),
            passiveStrategies: _zod.z.array(_zod.z.string())
        })
    })
});
const MetaDataEngagementCohortInsightResponseStream = _zod.z.object({
    data: EngagementCohortInsightResponseStream
}).extend(AiResponseEnvelope.shape);
const buildReviewCycleInsightSchema = (settings)=>{
    const insightFields = {
        summary: _zod.z.string()
    };
    // Only add fields for enabled sections
    if (settings.reviewToneDistribution) {
        insightFields.reviewToneDistribution = _zod.z.array(_zod.z.string()).or(_zod.z.string()).describe("Overall sentiment with percentage breakdown ex: [ Highly Positive: 43%, Moderately Positive: 29%, Neutral/Balanced: 14%, Moderately Negative: 14%, Highly Negative: 0% ]");
    }
    if (settings.highlightedReviews) {
        insightFields.highlightedReviews = _zod.z.object({
            topPerformers: _zod.z.array(_zod.z.string()).max(5).default([]),
            attentionRequired: _zod.z.array(_zod.z.string()).max(5).default([]),
            growthOpportunities: _zod.z.array(_zod.z.string()).max(5).default([])
        });
    }
    if (settings.keyStrengthsAndOpportunities) {
        insightFields.strengthsAnalysis = _zod.z.array(_zod.z.string()).default([]);
        insightFields.opportunitiesAnalysis = _zod.z.array(_zod.z.string()).default([]);
    }
    if (settings.commonThemesPositiveReviews) {
        insightFields.commonThemesForPositiveReviews = _zod.z.array(_zod.z.string()).default([]);
    }
    if (settings.commonThemesNegativeReviews) {
        insightFields.commonThemesForNegativeReviews = _zod.z.array(_zod.z.string()).default([]);
    }
    if (settings.recurringActionItems) {
        insightFields.recurringActionItems = _zod.z.array(_zod.z.string()).default([]);
    }
    if (settings.disconnectsAnalysis) {
        insightFields.disconnectsAnalysis = _zod.z.array(_zod.z.string()).default([]);
    }
    return _zod.z.object({
        createdAt: _zod.z.string().default(new Date().toISOString()),
        completed: _zod.z.boolean().default(false),
        createdBy: _zod.z.string().default("Automated Insights"),
        title: _zod.z.string(),
        startDate: _zod.z.string().default(new Date().toISOString()),
        completedDate: _zod.z.string().default(new Date().toISOString()),
        insight: _zod.z.object(insightFields).or(_zod.z.string())
    });
};
const ReviewCycleInsightResponseStream = _zod.z.object({
    createdAt: _zod.z.string().default(new Date().toISOString()),
    completed: _zod.z.boolean().default(false),
    createdBy: _zod.z.string().default("Automated Insights"),
    title: _zod.z.string(),
    startDate: _zod.z.string().default(new Date().toISOString()),
    completedDate: _zod.z.string().default(new Date().toISOString()),
    insight: _zod.z.object({
        summary: _zod.z.string(),
        reviewToneDistribution: _zod.z.array(_zod.z.string()).or(_zod.z.string()).describe("Overall sentiment with percentage breakdown ex: [ Highly Positive: 43%, Moderately Positive: 29%, Neutral/Balanced: 14%, Moderately Negative: 14%, Highly Negative: 0% ]").optional(),
        highlightedReviews: _zod.z.object({
            topPerformers: _zod.z.array(_zod.z.string()).max(5).default([]),
            attentionRequired: _zod.z.array(_zod.z.string()).max(5).default([]),
            growthOpportunities: _zod.z.array(_zod.z.string()).max(5).default([])
        }).optional(),
        strengthsAnalysis: _zod.z.array(_zod.z.string()).default([]).optional(),
        opportunitiesAnalysis: _zod.z.array(_zod.z.string()).default([]).optional(),
        commonThemesForPositiveReviews: _zod.z.array(_zod.z.string()).default([]).optional(),
        commonThemesForNegativeReviews: _zod.z.array(_zod.z.string()).default([]).optional(),
        recurringActionItems: _zod.z.array(_zod.z.string()).default([]).optional(),
        disconnectsAnalysis: _zod.z.array(_zod.z.string()).default([]).optional()
    }).or(_zod.z.string())
});
const MetaDataReviewCycleInsightResponseStream = _zod.z.object({
    data: ReviewCycleInsightResponseStream
}).extend(AiResponseEnvelope.shape);
const ChunkProcessingResponse = _zod.z.object({
    totalChunks: _zod.z.number(),
    completedChunks: _zod.z.number()
});
const MetaDataChunkProcessingResponse = _zod.z.object({
    data: ChunkProcessingResponse
}).extend(AiResponseEnvelope.shape);
const buildMeetingWorkspaceInsightSchema = (settings)=>{
    const insightFields = {
        executiveSummary: _zod.z.string()
    };
    // Only add fields for enabled sections
    if (settings.progressAndGrowth) {
        insightFields.progressAndGrowth = _zod.z.array(_zod.z.string());
    }
    if (settings.keyAccomplishmentsAndWins) {
        insightFields.keyAccomplishmentsAndWins = _zod.z.array(_zod.z.string());
    }
    if (settings.developmentAreasAndGrowthOpportunities) {
        insightFields.developmentAreasAndGrowthOpportunities = _zod.z.array(_zod.z.string());
    }
    if (settings.notableDiscussionsAndDecisions) {
        insightFields.notableDiscussionsAndDecisions = _zod.z.array(_zod.z.string());
    }
    if (settings.actionItemsAnalysis) {
        insightFields.actionItemAnalysis = _zod.z.string();
    }
    return _zod.z.object({
        createdAt: _zod.z.string().default(new Date().toISOString()),
        completed: _zod.z.boolean().default(false),
        createdBy: _zod.z.string().default("Automated Insights"),
        workspaceId: _zod.z.string(),
        workspaceName: _zod.z.string(),
        startDate: _zod.z.string(),
        endDate: _zod.z.string(),
        insight: _zod.z.object(insightFields)
    });
};
const MeetingWorkspaceInsightResponseStream = _zod.z.object({
    createdAt: _zod.z.string().default(new Date().toISOString()),
    completed: _zod.z.boolean().default(false),
    createdBy: _zod.z.string().default("Automated Insights"),
    workspaceId: _zod.z.string(),
    workspaceName: _zod.z.string(),
    startDate: _zod.z.string(),
    endDate: _zod.z.string(),
    insight: _zod.z.object({
        executiveSummary: _zod.z.string(),
        progressAndGrowth: _zod.z.array(_zod.z.string()).optional(),
        keyAccomplishmentsAndWins: _zod.z.array(_zod.z.string()).optional(),
        developmentAreasAndGrowthOpportunities: _zod.z.array(_zod.z.string()).optional(),
        notableDiscussionsAndDecisions: _zod.z.array(_zod.z.string()).optional(),
        actionItemAnalysis: _zod.z.string().optional()
    })
});
const MetaDataMeetingWorkspaceInsightResponseStream = _zod.z.object({
    data: MeetingWorkspaceInsightResponseStream
}).extend(AiResponseEnvelope.shape);
const buildTeamMeetingWorkspaceInsightSchema = (settings)=>{
    const insightFields = {
        executiveSummary: _zod.z.string()
    };
    if (settings.recurringThemesAndTopics) {
        insightFields.recurringThemesAndTopics = _zod.z.array(_zod.z.string());
    }
    if (settings.keyAccomplishmentsAndWins) {
        insightFields.keyAccomplishmentsAndWins = _zod.z.array(_zod.z.string());
    }
    if (settings.recurringChallengesAndBlockers) {
        insightFields.recurringChallengesAndBlockers = _zod.z.array(_zod.z.string());
    }
    if (settings.notableDiscussionsAndDecisions) {
        insightFields.notableDiscussionsAndDecisions = _zod.z.array(_zod.z.string());
    }
    if (settings.actionItemsAnalysis) {
        insightFields.actionItemAnalysis = _zod.z.string();
    }
    return _zod.z.object({
        createdAt: _zod.z.string().default(new Date().toISOString()),
        completed: _zod.z.boolean().default(false),
        createdBy: _zod.z.string().default("Automated Insights"),
        workspaceId: _zod.z.string(),
        workspaceName: _zod.z.string(),
        startDate: _zod.z.string(),
        endDate: _zod.z.string(),
        insight: _zod.z.object(insightFields)
    });
};
const TeamMeetingWorkspaceInsightResponseStream = _zod.z.object({
    createdAt: _zod.z.string().default(new Date().toISOString()),
    completed: _zod.z.boolean().default(false),
    createdBy: _zod.z.string().default("Automated Insights"),
    workspaceId: _zod.z.string(),
    workspaceName: _zod.z.string(),
    startDate: _zod.z.string(),
    endDate: _zod.z.string(),
    insight: _zod.z.object({
        executiveSummary: _zod.z.string(),
        recurringThemesAndTopics: _zod.z.array(_zod.z.string()).optional(),
        keyAccomplishmentsAndWins: _zod.z.array(_zod.z.string()).optional(),
        recurringChallengesAndBlockers: _zod.z.array(_zod.z.string()).optional(),
        notableDiscussionsAndDecisions: _zod.z.array(_zod.z.string()).optional(),
        actionItemAnalysis: _zod.z.string().optional()
    })
});
const MetaDataTeamMeetingWorkspaceInsightResponseStream = _zod.z.object({
    data: TeamMeetingWorkspaceInsightResponseStream
}).extend(AiResponseEnvelope.shape);
const buildPreMeetingPrepSchema = (settings)=>{
    const fields = {
        executiveSummary: _zod.z.string(),
        lastThreeMeetingsRecap: _zod.z.array(_zod.z.string())
    };
    if (settings.suggestedAgendaItems) {
        fields.suggestedAgendaItems = _zod.z.array(_zod.z.object({
            topic: _zod.z.string(),
            reason: _zod.z.string()
        }));
    }
    if (settings.recentFeedback) {
        fields.recentFeedback = _zod.z.array(_zod.z.string());
    }
    if (settings.recentReviews) {
        fields.recentReviews = _zod.z.string();
    }
    if (settings.surveyInsights) {
        fields.surveyInsights = _zod.z.string();
    }
    return _zod.z.object({
        createdAt: _zod.z.string().default(new Date().toISOString()),
        createdBy: _zod.z.string().default("Automated Insights"),
        completed: _zod.z.boolean().default(false),
        workspaceId: _zod.z.string(),
        workspaceName: _zod.z.string(),
        meetingId: _zod.z.string(),
        meetingName: _zod.z.string(),
        meetingDate: _zod.z.string(),
        ...fields
    });
};
const PreMeetingPrepResponseStream = _zod.z.object({
    createdAt: _zod.z.string().default(new Date().toISOString()),
    createdBy: _zod.z.string().default("Automated Insights"),
    completed: _zod.z.boolean().default(false),
    workspaceId: _zod.z.string(),
    workspaceName: _zod.z.string(),
    meetingId: _zod.z.string(),
    meetingName: _zod.z.string(),
    meetingDate: _zod.z.string(),
    executiveSummary: _zod.z.string(),
    lastThreeMeetingsRecap: _zod.z.array(_zod.z.string()),
    suggestedAgendaItems: _zod.z.array(_zod.z.object({
        topic: _zod.z.string(),
        reason: _zod.z.string()
    })).optional(),
    recentFeedback: _zod.z.array(_zod.z.string()).optional(),
    recentReviews: _zod.z.string().optional(),
    surveyInsights: _zod.z.string().optional()
});
const MetaDataPreMeetingPrepResponseStream = _zod.z.object({
    data: PreMeetingPrepResponseStream
}).extend(AiResponseEnvelope.shape);
const AskConfidenceLevel = _zod.z.enum([
    "high",
    "medium",
    "low"
]);
const AskScoreSource = _zod.z.enum([
    "vector",
    "hybrid",
    "rerank"
]);
const AskStreamStage = _zod.z.enum([
    "classifying",
    "searching",
    "reranking",
    "generating",
    "gathering_context"
]);
const AskSSEStatusEvent = _zod.z.object({
    type: _zod.z.literal("status"),
    stage: AskStreamStage,
    message: _zod.z.string().optional()
});
const AskSSEChunkEvent = _zod.z.object({
    type: _zod.z.literal("chunk"),
    text: _zod.z.string()
});
const AskSSEDoneEvent = _zod.z.object({
    type: _zod.z.literal("done"),
    sources: _zod.z.array(_zod.z.lazy(()=>AskSource)).optional(),
    confidence: AskConfidenceLevel,
    retrievalMetrics: _zod.z.object({
        totalChunksRetrieved: _zod.z.number(),
        chunksUsedInAnswer: _zod.z.number(),
        averageRelevanceScore: _zod.z.number(),
        scoreSource: AskScoreSource
    }).optional(),
    classification: _zod.z.object({
        agent: _zod.z.enum([
            "document",
            "general",
            "goal",
            "form",
            "interviewer",
            "unsupported"
        ]),
        complexity: _zod.z.enum([
            "simple",
            "complex"
        ]),
        reasoning: _zod.z.string(),
        requiresMultiStep: _zod.z.boolean().optional(),
        suggestedDomain: _zod.z.string().optional()
    })
});
const AskSSEErrorEvent = _zod.z.object({
    type: _zod.z.literal("error"),
    message: _zod.z.string()
});
const AskSSEToolCallEvent = _zod.z.object({
    type: _zod.z.literal("tool-call"),
    toolName: _zod.z.string(),
    args: _zod.z.unknown()
});
const AskSSEGoalSuggestion = _zod.z.object({
    id: _zod.z.string(),
    name: _zod.z.string(),
    target: _zod.z.number(),
    units: _zod.z.string(),
    assigneeId: _zod.z.string(),
    assigneeName: _zod.z.string(),
    startDate: _zod.z.string(),
    endDate: _zod.z.string(),
    categories: _zod.z.array(_zod.z.object({
        id: _zod.z.string(),
        name: _zod.z.string()
    })),
    description: _zod.z.string(),
    transparency: _zod.z.enum([
        "public",
        "private"
    ])
});
const AskSSEGoalsEvent = _zod.z.object({
    type: _zod.z.literal("goals"),
    suggestions: _zod.z.array(AskSSEGoalSuggestion)
});
const AskSSEFormQuestionType = _zod.z.enum([
    "text",
    "multiline",
    "multiple-select",
    "date",
    "goal-creation",
    "goal-discussion",
    "rating-scale",
    "multiple-choice",
    "instructions",
    "numeric"
]);
const AskSSEFormRatingScaleOption = _zod.z.object({
    value: _zod.z.union([
        _zod.z.number(),
        _zod.z.literal("")
    ]),
    name: _zod.z.string(),
    description: _zod.z.string().optional()
});
const AskSSEFormQuestionSuggestion = _zod.z.object({
    question: _zod.z.string(),
    subtext: _zod.z.string().optional(),
    type: AskSSEFormQuestionType,
    is_required: _zod.z.boolean(),
    choices: _zod.z.array(_zod.z.string()).optional(),
    add_scaling: _zod.z.array(AskSSEFormRatingScaleOption).optional(),
    rating_scale: _zod.z.array(AskSSEFormRatingScaleOption).optional(),
    min: _zod.z.number().optional(),
    max: _zod.z.number().optional(),
    decimals: _zod.z.boolean().optional()
});
const AskSSEFormSuggestion = _zod.z.object({
    id: _zod.z.string(),
    name: _zod.z.string(),
    questions: _zod.z.array(AskSSEFormQuestionSuggestion)
});
const AskSSEFormsEvent = _zod.z.object({
    type: _zod.z.literal("forms"),
    suggestions: _zod.z.array(AskSSEFormSuggestion)
});
const AskSSEFormQuestionsEvent = _zod.z.object({
    type: _zod.z.literal("formQuestions"),
    suggestions: _zod.z.array(AskSSEFormQuestionSuggestion.extend({
        id: _zod.z.string()
    })).min(1).max(3)
});
const AskSSEInterviewNotesEvent = _zod.z.object({
    type: _zod.z.literal("interview_notes"),
    notes: _zod.z.record(_zod.z.string(), _zod.z.unknown()),
    harness: _harnesstypes.InterviewerHarnessType
});
const AskSSECompetencyLevel = _zod.z.object({
    rank: _zod.z.number().int().min(1).max(5),
    name: _zod.z.string(),
    description: _zod.z.string()
});
const AskSSECompetencySuggestion = _zod.z.object({
    id: _zod.z.string(),
    name: _zod.z.string(),
    description: _zod.z.string(),
    isCompanyWide: _zod.z.boolean().default(true),
    status: _zod.z.literal("active"),
    levels: _zod.z.array(AskSSECompetencyLevel),
    ratingScale: _zod.z.null()
});
const AskSSECompetenciesInterviewerOutput = _zod.z.object({
    type: _zod.z.literal("interviewer_output"),
    harness: _zod.z.literal("competency"),
    suggestions: _zod.z.array(AskSSECompetencySuggestion)
});
const AskSSEReportingAnalyticsInterviewerOutput = _zod.z.object({
    type: _zod.z.literal("interviewer_output"),
    harness: _zod.z.literal("reporting_analytics_report"),
    reportConfig: _zod.z.record(_zod.z.string(), _zod.z.unknown())
});
const AskSSEInterviewerOutputEvent = _zod.z.discriminatedUnion("harness", [
    AskSSECompetenciesInterviewerOutput,
    AskSSEReportingAnalyticsInterviewerOutput
]);
const AskSSEExitInterviewerEvent = _zod.z.object({
    type: _zod.z.literal("exit_interviewer")
});
const AskSSEEventSchema = _zod.z.discriminatedUnion("type", [
    AskSSEStatusEvent,
    AskSSEChunkEvent,
    AskSSEToolCallEvent,
    AskSSEDoneEvent,
    AskSSEErrorEvent,
    AskSSEGoalsEvent,
    AskSSEFormsEvent,
    AskSSEFormQuestionsEvent,
    AskSSEInterviewNotesEvent,
    AskSSEInterviewerOutputEvent,
    AskSSEExitInterviewerEvent
]);
const AskSource = _zod.z.object({
    s3FileId: _zod.z.string(),
    filename: _zod.z.string(),
    chunkCount: _zod.z.number(),
    relevanceScore: _zod.z.number()
});
const HasAccessibleDocumentsResponse = _zod.z.object({
    hasDocuments: _zod.z.boolean()
});
